module.exports = __webpack_public_path__ + "static/media/rapid_revision_reg.e2e689d6.png";